module.exports = __webpack_public_path__ + "static/media/3.cbf4c424.jpg";